export const CORETOOLSDETAILS = 'CORETOOLSDETAILS';
export const NONCORETOOLSDETAILS = 'NONCORETOOLSDETAILS';
export const CUSTOMTOOLDETAILS = 'CUSTOMTOOLDETAILS';
export const TOOLS_ORDER_ID  = 'TOOLS_ORDER_ID';
export const CARTRIDGE_ORDER_ID = 'CARTRIDGE_ORDER_ID';
export const CARTRIDGES = 'CARTRIDGES';
export const USERROLE = 'USERROLE';